<template>
	<div>
		<h2>Movimiento {{this.id}}</h2>
		<div name='movimiento-ver' v-if='movimientoSolo !=null'>
			<li v-for="movi in movimientoSolo">	
				<h2 v-if="movi.idContrato !=null">{{movi.idContrato}}</h2>

				<p v-if="movi.importe !=null">{{movi.importe}}</p>
				<p v-if="movi.tipo !=null">{{movi.tipo}}</p>

			</li>

		</div>
		<span v-else>Cargando movimiento</span>
	</div>
</template>

<script>
	import axios from 'axios';
	export default{
		name:'movimiento-detalle',
	
		mounted(){
			this.id=this.$route.params.id;
			axios.get('https://www.directodo.com/Rentus/accesosdb/leeUnMovimiento.php?id='+this.id)
  		         .then((respue) => {
  		     		this.movimientoSolo=respue.data;
  			 	 });
		},
		data(){
			return{
				id: null,
				movimientoSolo: null	
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/Movimiento-ver.vue